<template>
  <div class="zy-box school-box major-box">
    <Breadcrumb></Breadcrumb>
    <el-row class="zy-school" type="flex" justify="space-between">
        <el-col :span="16">
        <div>
          <el-tabs type="border-card" v-model="selectType" slot="content" class="rank-box zy-list" @tab-click="handleChangeCard">
            <el-tab-pane :label="card.name" v-for="card in cardList" :key="card.key" :name="card.key">
              <div class="search-img header-search">
                  <el-input placeholder="查专业" v-model="searchSpecial" @keyup.enter.native="searchSpecialListHandler()"> 
                      <template slot="append">
                          <img src="../../assets/images/sousuo.png" alt="搜索" @click="searchSpecialListHandler()" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="!isShowSearch">
                          <img src="../../assets/images/sousuo-diff.png" alt="搜索" @click="searchSpecialListHandler()" @mouseenter="isShowSearch=!isShowSearch" @mouseleave="isShowSearch=!isShowSearch" v-if="isShowSearch">
                      </template>
                  </el-input>
              </div>
              <template v-if="selectType != 3">
                <div class="province-list">
                  <div class="title-box">专业类型：</div>
                  <ContentLoader :base-url="$route.fullPath" height="56" width="670" viewBox="0 0 670 56" v-if="typeList.length == 1" primaryColor="#f0f2f5" secondaryColor="#EFEFEF">
                      <rect x="10" y="0" width="670" height="20" />
                      <rect x="10" y="30" width="670" height="20" />
                  </ContentLoader>
                  <div class="province-name" v-else>
                    <a v-for="(item,index) in typeList" :key="index" :class="activeTag == index?'active-tag':''" @click="activeTagHandler(index)">{{item.level2_name}}</a>
                  </div>
                </div>
              </template>

                <div v-if="!searchSchoolStatus1">
                  <ContentLoader :base-url="$route.fullPath" height="200" width="670" viewBox="0 0 670 200" primaryColor="#f0f2f5" secondaryColor="#EFEFEF"  v-for="item in 20" :key="item">
                      <rect x="0" y="20" width="40" height="20" />
                      <rect x="0" y="55" width="70" height="20" />
                      <rect x="20" y="120" width="30" height="20" />
                      <rect x="20" y="150" width="300" height="20" />
                      <rect x="570" y="130" width="100" height="20" />
                      <rect x="0" y="99" width="725" height="1" />
                      <rect x="20" y="199" width="725" height="1" />
                  </ContentLoader>
                </div>
              <el-row class="collapse-box" v-else-if="searchSchoolStatus">
                  <div class="collapse-list" v-for="(item,index) in levelList" :key="index">
                    <h2>{{item.level2_name}}</h2>
                    <div v-for="(item1,index1) in item.levelList" :key="index1">
                      <h4>{{item1.level3_name}}</h4>
                      <div class="major-list" v-for="(item2,index2) in item1.levelList1" :key="index2">
                        <el-row class="major-infor">
                          <el-col :span="17">
                          <div class="zytb-school-name">
                              {{item2.special_name}}
                          </div>
                          <div class="zytb-school-tag">
                              <span>现修年限{{item2.limit_year ? item2.limit_year: '--'}}</span>
                              <span>授予学位:{{item2.degree ? item2.degree: '--'}}</span>
                              <span>男女比例:{{item2.boy_rate}}/{{item2.girl_rate}}</span>
                          </div>
                          </el-col>
                          <el-col :span="4">
                              <el-button @click="clickHandler(item2.special_id)">查看专业详情</el-button>
                          </el-col>
                          <div class="con-clear"></div>
                          <el-row class="con-line"></el-row>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <el-pagination
                      background
                      layout="prev, pager, next, jumper"
                      :total="levelTotal" :page-size="20" @current-change="getSpecialListHandler" :current-page.sync='currentPage' v-if="levelTotal > 0">
                  </el-pagination>
              </el-row>
              <div v-if="!searchSchoolStatus" class="no-data-box">
                  <img src="../../assets/images/null.png" alt="没有数据">
                  <p>没有查询到专业</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        </el-col>
        <el-col :span="8" class="zyb-box"> 
          <SchoolRank></SchoolRank>
          <News></News>
        </el-col>
    </el-row>
  </div>
</template>

<script>
import { getAllLevel2, getSpecialList } from '@/api/major'
import { ContentLoader } from 'vue-content-loader'
import { mapState } from 'vuex'
export default {
  components: {
    ContentLoader
  },
  data() {
    return {
      cardList: [{key: '1', name: '本科(普通)'},{key: '230', name: '本科(职业)'},{key: '2', name: '专科(职高)'},{key: '3', name: '艺术生'}],
      isShowSearch: false,
      typeList: [
        {level2_name:'全部'},
      ],
      activeTag: 0,
      selectType: '1',
      selectType1: '1',
      searchSpecial: '',
      selectLevel: '',
      levelTotal: 0,
      levelList: [],
      currentPage: 1,
      searchSchoolStatus: true,
      searchSchoolStatus1: false,
    }
  },
      computed: {
        ...mapState({
            requestCount: state => state.user.requestCount,
        })
    },
    watch: {
        requestCount (newVal) {
            if(newVal > 0) {
                this.searchSchoolStatus1 = false;
            } else {
                this.searchSchoolStatus1 = true;
            }
        },
    },
  created() {
    this.$store.commit('user/ADDCOUNT', 0);
    this.getAllLevelHandler();
    this.getSpecialListHandler('1');
  },
  methods: {
    clickHandler(special_id) {
      if(!special_id) {
        this.$message({
            message: '暂无相关专业信息',
            type: 'warning'
        })
        return
      }
      this.$router.push({
        path: '/majorDetail',
        query: {
          special_id: special_id
        }
      })
    },
    activeTagHandler(index) {
      this.activeTag = index;
      this.selectLevel = this.typeList[index].level2;
      this.levelList = [];
      this.levelTotal = '';
      this.currentPage = 1;
      this.getSpecialListHandler('1');
    },
    getAllLevelHandler() {
      getAllLevel2(this.selectType).then( res=> {
        this.typeList.push(...res.data);
      })
    },
    searchSpecialListHandler() {
      this.levelTotal = '';
      this.currentPage = 1;
      this.getSpecialListHandler('1');
    },
    handleChangeCard(e) {
      this.selectType = this.cardList[e.index].key;
      this.selectType1 = this.cardList[e.index].key;
      this.typeList = [{level2_name:'全部'}];
      this.selectLevel = '';
      this.activeTag = 0;
      this.searchSpecial = '';
      this.levelList = [];
      this.levelTotal = '';
      this.currentPage = 1;
      if(this.selectType == 3) {
        this.selectType1 = 1;
        this.selectLevel = 14;
      } else {
        this.selectType1 = this.selectType;
        this.getAllLevelHandler();
      }
      this.getSpecialListHandler('1');
    },
    getSpecialListHandler(page) {
      getSpecialList(this.searchSpecial,this.selectType1,this.selectLevel,page).then( res=> {
        this.levelTotal = res.data.count;
        if(res.data.count == 0) {
            this.searchSchoolStatus = false;
            return
        }
        this.searchSchoolStatus = true;
        let data = res.data.data;
        let newData = [];
        data.map((item,index) => {
          let indexData = newData.findIndex(function(item1){
              return item.level2_name == item1.level2_name; 
          })
          if(indexData != -1) {
            let obj = newData[indexData];
            let indexData1 = obj.levelList.findIndex(function(item1){
              return item.level3_name == item1.level3_name; 
            })
            if(indexData1 != -1) {
              let obj1 = obj.levelList[indexData1];
              let levelList1 = obj1.levelList1;
              levelList1.push(item);
              obj1.levelList1 = levelList1;
              obj.levelList[indexData1] = obj1;
              this.$set(newData,indexData,obj);
            } else {
              let obj1 = {};
              let levelList1 = [];
              obj1.level3_name = item.level3_name;
              levelList1.push(item);
              obj1.levelList1 = levelList1;
              obj.levelList.push(obj1);
              this.$set(newData,indexData,obj);
            }
          } else {
            let obj = {};
            let obj1 = {};
            let levelList = [];
            let levelList1 = [];
            levelList1.push(item);
            obj1.level3_name = item.level3_name;
            obj1.levelList1 = levelList1;
            obj.level2_name = item.level2_name;
            levelList.push(obj1);
            obj.levelList = levelList;
            newData.push(obj);
          }
        })
				this.levelList = newData;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/css/variables.scss";
  .zy-img {
    @include gwidth;
    margin-top: 10px;
  }
  .zy-school {
    @include gwidth;
    .el-col-7 {
      width: 32.5%;
    }
    .el-col-16 {
      position: relative;
      padding-right: 16px;
    }
  }
  .rank-box {
    border: none;
    background: #f5f7fa;
    box-shadow: none!important;
    margin-top: 24px;
  }
  .province-list {
      @include gflex;
      font-size: 0;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 10px;
      .title-box {
        width: 78px;
        font-size: 14px;
        text-align: right;
        color: #909399;
        margin-top: 3px;
      }
      a {
        display: inline-block;
        margin-left: 20px;
        font-size: 14px;
        color: #5e6166;
        cursor: pointer;
        text-align: center;
        margin-bottom: 10px;
        padding: 3px 5px;
      }
      a:hover {
        color: $common-color;
      }
      .active-tag {
        color: #ffffff!important;
        background: $common-color;
        border-radius: 4px;
      }
      .province-name {
        width: calc(100% - 4px);
        position: relative;
        left: -13px;
      }
    }
    .search-img {
        margin-bottom: 24px;
        height: 44px;
        line-height: 44px;
        img {
          width: 32px;
          height: 32px;
          margin-top: 5px;
          margin-left: 6px;
          cursor: pointer;
        }
        input {
          background: #fff!important;
        }
        button {
          width: 100px;
          height: 44px;
          border: none!important;
          background: linear-gradient(270deg,$common-color, #60aaff 99%);
          border-radius: 8px;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          border: none;
          margin-left: 16px;
          position: relative;
          top: 1px;
        }
    }
    .collapse-box {
      width: 100%;
      border-top: 1px solid #f0f2f5;
      font-size: 0;
      h2 {
        font-size: 22px;
        font-weight: 600;
        color: #332e2c;
        margin-top: 16px;
        height: 44px;
        line-height: 44px;
        background: linear-gradient(270deg,#ffffff, #fff3ee);
        border-radius: 8px;
        padding-left: 16px;
      }
      h4 {
        font-size: 18px;
        font-weight: 600;
        color: $common-color;
        padding-bottom: 18px;
        margin-bottom: 0;
        border-bottom: 1px solid #f0f2f5;
        margin-top: 18px;
        margin-left: 20px;
      }
      .major-infor {
        height: 100px;
        padding: 20px 0 30px 20px;
      }
      .el-col-4 {
          float: right;
      }
      .zytb-school-name {
          font-size: 16px;
          font-weight: 400;
          color: #2c2e33;
      }
      .zytb-school-tag span {
          display: inline-block;
          padding: 3px 8px;
          font-size: 12px;
          color: #909399;
          height: 22px;
          background: #f0f2f5;
          border-radius: 4px;
          line-height: 22px;
          margin-right: 4px;
      }
      .zytb-school-tag {
          margin-top: 10px;
      }
      button {
          width: 100px;
          height: 30px;
          border: 1px solid $common-color;
          border-radius: 5px;
          color: $common-color!important;
          font-size: 14px;
          text-align: center;
          line-height: 30px;
          padding: 0;
          margin-top: 15px;
      }
      .el-col-4 {
          text-align: right;
      }
      button:hover {
          background-color: #fff;
      }
      .con-line {
          width: calc(100% - 20px);
          height: 1px;
          background: #f0f2f5;
          position: absolute;
          right: 0;
          bottom: 0;
      }
    }
    .zyb-box {
      background: none;
      border-radius: 0;
      box-shadow: none;
      position: relative;
    }
    .no-data-box {
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-top: 80px;
      img {
          width: 110px;
          height: 110px;
      }
      p {
          font-size: 16px;
          text-align: center;
          color: #abaeb3;
      }
    }
</style>